export const BRAND_TAGS = {
    BRAND_LIST: "getBrandList",
} as const;